import { concat } from '../observable/concat';
import { of } from '../observable/of';
export function endWith(...array) {
  return source => concat(source, of(...array));
}
